import styles from "./../../sass/landing/hero.module.scss";
import classNames from "classnames";
import { Dialog, useMediaQuery, DialogContent, IconButton, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import MailchimpSubscribe from "react-mailchimp-subscribe"
import { CustomForm } from "./News";
import { CloseCircleOutline } from "mdi-material-ui";

const SubscribeModal = ({isOpened, closeModal, successUrl, submitButtonLabel}) => {
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <>
      <Dialog 
        fullScreen={isFullScreen}
        open={isOpened}
        onClose={() => closeModal()}
        sx={{
          '& .MuiPaper-root': {
            //backgroundImage: "linear-gradient(90deg, #8642fe 0%, #1b81f9 50%, #08f0bf 100%)",
            padding: "5px",
          },
        }}
      >
        <div className={classNames(styles["modal-wrapper"],"w-100")}>
          <div className={classNames(styles["modal-header"],"d-flex justify-content-between align-items-center")}>
            <Typography variant="h6">One more step...</Typography>
            <IconButton size="large" onClick={() => closeModal()}>
              <CloseCircleOutline />
            </IconButton>
          </div>
          <DialogContent sx={{ minWidth: isFullScreen ? "auto" : "400px !important" }}>
            <MailchimpSubscribe
              url={'https://bluespherecarbon.us1.list-manage.com/subscribe/post?u=dd44cd897074f9847d1fd163a&amp;id=d07142e5a3'}
              render={({ subscribe, status, message }) => (
                <>
                  <CustomForm
                    status={status}
                    message={message}
                    onValidated={
                      formData => subscribe(formData)
                    }
                    props={this}
                    extraFields={true}
                    submitButtonLabel={submitButtonLabel}
                    successUrl={successUrl}
                    onSuccess={() => {
                      closeModal();
                    }}
                  />
                </>
              )}
            />
          </DialogContent>
        </div>
      </Dialog>
    </>
  );
};

export default SubscribeModal;
